import React from 'react';
import { CheckCircleIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
import { trackAddToCart, CART_URL } from '../lib/metaPixel';
export function PricingSection() {
  const includes = [<strong data-id="element-270">Ebook completo Plan Anti Panza.</strong>, 'Sistema de 12 semanas.', '8 módulos paso a paso.', '6 bonos digitales incluidos.', 'Acceso inmediato.', 'Descarga digital.', 'Garantía de 7 días.'];
  return <section className="py-14 md:py-20 bg-black border-t border-zinc-900 pt-[20px] pb-[20px]" data-id="element-271">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-6xl mx-auto" data-id="element-273">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display text-white mb-20 md:mb-24 text-center uppercase tracking-tight leading-[0.95]" data-id="element-274">
            Accedé hoy al Plan Anti Panza con{' '}
            <span className="text-orange-500" data-id="element-275">50% OFF</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-276">
            {/* Left: Product Image */}
            <div className="relative" data-id="element-277">
              <img src="https://cdn.magicpatterns.com/uploads/9EDFvVH9k6MsB15fyAgWRc/MOCKUP_BUNDLE_COMPLETO_1;1_2_reducido.webp" alt="Plan Anti Panza Digital" className="w-full rounded-3xl drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-278" />
              <div className="absolute -top-8 -right-8 md:-right-12 bg-red-600 text-white w-32 h-32 md:w-40 md:h-40 rounded-full flex items-center justify-center shadow-2xl transform rotate-12 border-4 border-black" data-id="element-279">
                <div className="text-center" data-id="element-280">
                  <div className="text-4xl md:text-5xl font-display tracking-tight" data-id="element-281">
                    -50%
                  </div>
                  <div className="text-sm md:text-base font-bold uppercase tracking-widest" data-id="element-282">
                    Descuento
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Pricing */}
            <div data-id="element-283">
              <div className="bg-zinc-900/80 border border-orange-500/50 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(249,115,22,0.1)]" data-id="element-284">
                <div className="text-center mb-10" data-id="element-285">
                  <p className="text-zinc-400 text-lg mb-2 uppercase tracking-wider font-bold" data-id="element-286">
                    Valor regular
                  </p>
                  <p className="text-3xl text-zinc-600 line-through font-bold mb-6" data-id="element-287">
                    $15.98 USD
                  </p>

                  <p className="text-orange-500 text-xl mb-4 font-bold uppercase tracking-wider" data-id="element-288">
                    Hoy pagás solo
                  </p>
                  <div className="text-6xl md:text-[5rem] font-display text-white mb-2 tracking-tight leading-none" data-id="element-289">
                    <PriceDisplay usdAmount={7.99} data-id="element-290" />
                  </div>
                </div>

                <div className="space-y-4 mb-10 bg-black/30 p-6 rounded-2xl border border-zinc-800" data-id="element-291">
                  {includes.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-292">
                      <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-293" />
                      <span className="text-zinc-200 text-lg" data-id="element-294">{item}</span>
                    </div>)}
                </div>

                <a href={CART_URL} onClick={() => trackAddToCart({
                value: 7.99,
                currency: 'USD',
                content_name: 'Plan Anti Panza'
              })} className="block w-full bg-orange-500 hover:bg-orange-400 text-white font-black text-xl md:text-2xl py-6 rounded-xl uppercase tracking-wide transition-all transform hover:scale-[1.02] active:scale-[0.98] text-center shadow-[0_0_40px_rgba(249,115,22,0.4)] mb-6" data-id="element-295">
                  Quiero acceder al Plan Anti Panza
                </a>

                <div className="text-center space-y-6" data-id="element-296">
                  <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-zinc-400 font-medium" data-id="element-297">
                    <div className="flex items-center gap-1.5" data-id="element-298">
                      <LockIcon className="w-4 h-4 text-green-500" data-id="element-299" />
                      <span data-id="element-300">Pago 100% seguro</span>
                    </div>
                    <div className="flex items-center gap-1.5" data-id="element-301">
                      <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-302" />
                      <span data-id="element-303">Garantía de 7 días</span>
                    </div>
                  </div>

                  <div className="flex items-center justify-center flex-wrap gap-3" data-id="element-304">
                    <div className="bg-zinc-800/50 border border-zinc-700 px-4 py-2 rounded-lg text-xs font-bold text-zinc-400 tracking-wider" data-id="element-305">
                      VISA
                    </div>
                    <div className="bg-zinc-800/50 border border-zinc-700 px-4 py-2 rounded-lg text-xs font-bold text-zinc-400 tracking-wider" data-id="element-306">
                      MASTERCARD
                    </div>
                    <div className="bg-zinc-800/50 border border-zinc-700 px-4 py-2 rounded-lg text-xs font-bold text-zinc-400 tracking-wider" data-id="element-307">
                      AMEX
                    </div>
                    <div className="bg-[#009EE3]/10 border border-[#009EE3]/40 px-4 py-2 rounded-lg text-xs font-bold text-[#00B1EA] tracking-wider flex items-center gap-1.5" data-id="element-308">
                      <span className="inline-block w-2 h-2 rounded-full bg-[#00B1EA]" data-id="element-309" />
                      MERCADO PAGO
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}